export const EnforceOfficeDashboardV2 = 'ARF-881-enforce-office-dashboard-v2';
export const EnforcePaymentHistoryTable = 'ARF-949-enforce-update-payment-history-table';
